module.exports = __webpack_public_path__ + "img/4.9047d090.jpg";